import React, { useMemo, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { getWaterUseTypeListQuery } from '../../../../slices/waterUseType/thunk';
import AddEditWaterUseTypeModal from './Add_Edit/AddEditWaterUseType';
import DeleteWaterUseTypeModal from './Delete/DeleteWaterUseType';
import { Icons } from '../../../../utils/Icons';

const WaterUseTypeList = () => {
	const history = useNavigate();

	const [dataWaterUseType, setDataWaterUseType] = useState({});
	const [refetch, setRefetch] = useState(0);

	const toggleRefetch = () => {
		setRefetch(prev => prev + 1);
	};
	const [isEdit, setIsEdit] = useState(false);

	// Delete WaterUseType
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = data => {
		setDataWaterUseType(data);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = data => {
		setDataWaterUseType(data);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				enableSorting: false,
				enableColumnFilter: false,
				enableGlobalFilter: false,
				enableColumnActions: false,
				accessorKey: 'waterUseTypes',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex justify-content-center'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const dataData = cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(dataData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const dataData = cellProps.row.original;
													handleClickDelete(dataData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'name',
				size: 'auto',
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						<CardBody>
							<ODataGrid
								columns={columns}
								getDataFunc={getWaterUseTypeListQuery}
								baseFilters={{
									disable: { $eq: false }
								}}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								refetchRemoteData={refetch}
								nameFile={'tipos-uso-agua'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataWaterUseType({});
											handleToggleModal();
										},
										title: 'Crear Tipo de Uso de Agua',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditWaterUseTypeModal
				dataWaterUseType={dataWaterUseType}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
			<DeleteWaterUseTypeModal
				dataWaterUseType={dataWaterUseType}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
				toggleRefetch={toggleRefetch}
			/>
		</React.Fragment>
	);
};

export default WaterUseTypeList;
